export enum SourceType {
	web = 'web',
	app = 'app',
}
